export default {
  state: {
    currBreadcrumb: null
  },
  mutations: {
    setBreadcrumb(state, payload) {
      state.currBreadcrumb = payload
    }
  },
  actions: {
    setBreadcrumb: ({
      commit
    }, payload) => {
      commit('setBreadcrumb', payload)
    },
    setRouteBreadcrumb: ({
      commit
    }, payload) => {
      if(DEBUG) console.log('pyload :>> ', pyload)
      commit('setBreadcrumb', payload)
    }
  },
  getters: {
    getBreadcrumb(state) {
      // dispatch('setBreadcrumb', value)
      return state.currBreadcrumb
    }

  }
}
